export const Strings = {
  SORRY: "Sorry !",
  INVALID_TOKEN: "Token Expired !",
  LOOKS_LIKE: "You seem to have landed on the wrong page.",
  INVALID_TOKEN_DESC: "The Link you are trying to access is expired or Invalid.",
  PLEASE_CLICK: "Click the sign-up button below to create your account.",
  FIELDS: " fields.Our support team will contact you soon.",
  GET_EARLY_ACCESS: " Get Early Access",
  PRIVACY: "Privacy",
  SIGN_UP: "Sign up",
  AND: "and",
  GO_HOME: "Go Home",
  REACH_OUT: " It is now under process. We will reach out to you soon.",
  EMAIL_VERIFIED: "Email id verified successfully, redirecting to login page.",
  EMAIL_VERIFIED_SETUP: "Email verified successfully, redirecting to workspace setup.",
  SOMETHING_WENT_WRONG: "Something went wrong.",
  Exist_TENANT: "exist-tenant=true",
  INVITATION_TOKEN: "invitation_token",
  host: "host",
  REQ_RECIEVED: "We have received your request.",
  ERROR: "Error",
  HI_THERE: "Hi There !",
  CANCEL: "Cancel",
  YOUR_ACCOUNTS: "Your Accounts",
  CONTINUE_WITH_ACC: " Continue with this account",
  CHOOSE_ONE_TENANT: "    Choose one tenant for Login",
  TERMS: "Terms.",
  // ── Email-verification actionable error copy (inline toast variant) ──
  VERIFY_EMAIL_TAKEN: "This email is already registered. Please log in instead.",
  VERIFY_DOMAIN_TAKEN: "Your company is already registered on ReachIQ. Please log in or ask your workspace admin to invite you.",
  VERIFY_SETUP_INCOMPLETE: "Please complete your workspace setup before verifying your email.",
  VERIFY_PAYMENT_PENDING: "Payment hasn't been completed for your selected plan. Please finish payment to continue.",
  VERIFY_TOKEN_MISSING: "The verification link is incomplete. Please use the link from your email again.",
};
